import * as Yup from "yup"

export const validationSchema = Yup.object().shape({
  userFullName: Yup.string().min(3, "Nama Minimal 3 karakter").required("*Nama harus diisi"),
  companyName: Yup.string()
    .min(3, "Minimal 3 karakter")
    .max(30, "*Maksimal 30 karakter")
    .required("*Perusahaan harus diisi"),
  userEmail: Yup.string().required("*Email harus diisi").email("*Email tidak valid"),
  userPhoneNumber: Yup.string()
    .min(10, "*Nomor telepon minimal 11 angka")
    .max(12, "*Nomor telepon maksimal 13 angka")
    .required("Telepon harus diisi"),
  services: Yup.array().min(1, "*Pilih Minimal satu").required("*Bidang harus diisi"),
  programType: Yup.string().required("*Program harus diisi"),
  numberOfEmployeer: Yup.string().required("*Jumlah karyawan harus diisi"),
  description: Yup.string().required("*Detail kebutuhan wajib diisi"),
})
